import { ClickAwayListener, Tabs } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import React, { useCallback, useEffect, useState } from 'react';
import { Switch, useHistory, useLocation } from 'react-router-dom';
import HeaderContainer from '../../components/Header/index';
import TabWithSubHeader from '../../components/TabWithSubHeader/TabWithSubHeader';
import { isAuthenticatedFromGDP } from '../../store/actions/authActions';
import PeopleManagementNavigation from '../PeopleManagementNavigation/index';
import PersonnelDepartmentPanelNavigation from '../PersonnelDepartmentPanelNavigation';
import Route from '../Route';
import { HoverMenuItem, RouteItem, ROUTES } from '../routes';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tabsContainer: {
      backgroundColor: theme.palette.background.paper,
      minHeight: 36,
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
    tabContent: {
      minHeight: 36,
      textTransform: 'none',
    },
  }),
);

const MainNavigation: React.FC = () => {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const [, setAnchorElPopover] = useState<HTMLElement | null>(null);
  const [openPopoverMenu, setOpenPopoverMenu] = useState(false);
  const [, setItemsSubMenu] = useState<HoverMenuItem[]>([]);
  const [mainRoutes, setMainRoutes] = useState<RouteItem[]>([]);

  const [tabSelected, setTabSelected] = useState(() => {
    return mainRoutes.findIndex(item => location.pathname.includes(item.path));
  });

  const handleTabChange = useCallback(
    (_event: React.ChangeEvent<unknown>, newValue: number) => {
      setTabSelected(newValue);
    },
    [],
  );

  const handleSubMenuClose = useCallback(() => {
    setOpenPopoverMenu(false);
    setAnchorElPopover(null);
  }, []);

  const handleTabClick = useCallback(
    (tabItem: RouteItem) => {
      handleSubMenuClose();
      history.push(tabItem.path);
    },
    [history, handleSubMenuClose],
  );

  const handleSubMenuOpen = useCallback(
    (
      subMenuItems: HoverMenuItem[] | undefined,
      event: React.MouseEvent<HTMLElement, MouseEvent>,
    ) => {
      if (
        subMenuItems !== null &&
        subMenuItems !== undefined &&
        subMenuItems.length > 0
      ) {
        setItemsSubMenu(subMenuItems);
        setOpenPopoverMenu(true);
        setAnchorElPopover(event.currentTarget);
      }
    },
    [],
  );

  useEffect(() => {
    isAuthenticatedFromGDP()
      ? setMainRoutes([ROUTES.PEOPLE_MANAGEMENT])
      : setMainRoutes([
          ROUTES.PEOPLE_MANAGEMENT,
          ROUTES.PERSONNEL_DEPARTMENT_PANEL,
        ]);
  }, []);

  return (
    <>
      <HeaderContainer />

      <ClickAwayListener onClickAway={handleSubMenuClose}>
        <Tabs
          className={classes.tabsContainer}
          value={tabSelected}
          onChange={handleTabChange}
          textColor="inherit"
          variant="scrollable"
          scrollButtons="auto"
        >
          {mainRoutes.map((item: RouteItem, index: number) => (
            <TabWithSubHeader
              key={index}
              data-key={index}
              label={item.title}
              className={classes.tabContent}
              onClick={() => handleTabClick(item)}
              onMouseEnter={event => handleSubMenuOpen(item.subMenu, event)}
              aria-owns={
                openPopoverMenu ? `mouse-over-popover-${index}` : undefined
              }
            />
          ))}
        </Tabs>
      </ClickAwayListener>

      <Switch>
        <Route
          path={ROUTES.PEOPLE_MANAGEMENT.path}
          component={PeopleManagementNavigation}
        />
        {!isAuthenticatedFromGDP() && (
          <Route
            path={ROUTES.PERSONNEL_DEPARTMENT_PANEL.path}
            component={PersonnelDepartmentPanelNavigation}
          />
        )}
      </Switch>
    </>
  );
};

export default MainNavigation;
